import script from "./MyAccountSide.vue?vue&type=script&setup=true&lang=js"
export * from "./MyAccountSide.vue?vue&type=script&setup=true&lang=js"

import "./MyAccountSide.vue?vue&type=style&index=0&id=32171411&lang=scss"

const __exports__ = script;

export default __exports__